import { put, takeLatest } from 'redux-saga/effects'
import { registerRecoveryOtps as submit } from '../api/registerRecoveryOtps'
import {
  recoveryOtpsRegisterSucceeded,
  recoveryOtpsRegisterFailed
} from '../../actions/mfaSettings'
import {
  RECOVERY_OTPS_REGISTER,
  RECOVERY_OTPS_RENEW
} from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'
import { push } from 'connected-react-router'
import { SETUP_MFA } from '../../constants/routes'

export function* requestRecoveryOtps({ request }, action) {
  const { isFromSettings } = action.payload || {}

  const handleSuccessResult = recoveryCodeList => {
    if (action.type === RECOVERY_OTPS_REGISTER) {
      return put(
        push(SETUP_MFA, {
          recoveryCodeList,
          isFromSettings
        })
      )
    } else {
      return put(recoveryOtpsRegisterSucceeded({ recoveryCodeList }))
    }
  }

  yield executeSaga(
    request,
    null,
    ({ otps_list: recoveryCodeList }) => handleSuccessResult(recoveryCodeList),
    error => put(recoveryOtpsRegisterFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: submit }) {
  yield takeLatest(
    [RECOVERY_OTPS_RENEW, RECOVERY_OTPS_REGISTER],
    requestRecoveryOtps,
    { request }
  )
}
